var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-main',{staticClass:"app-main",class:{ 'no-padding': _vm.isFullScreen }},[_c('transition',{attrs:{"name":"fade-transform","mode":"out-in"}},[_c('router-view',{key:_vm.key})],1),_c('fixedToolbar',{attrs:{"right":0,"bottom":140,"scroll-container-selector":'.app-main'},on:{"contact":_vm.onContact,"item-click":_vm.onItemClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }